/* Lunaice: przyklejony pasek zakupu na karcie produktu (snippet lunaice-sticky-buy, 2026-10-18; poprawki z audytu
   2026-10-18, A4). Pasek widać, gdy główny przycisk „Dodaj do koszyka” jest poza ekranem, a stopki nie widać:
   - przycisk nad ekranem (przewinięty) → kliknięcie paska klika główny przycisk: ten sam wariant i ten sam formularz Dawn
     (product-form.js otwiera szufladę koszyka i pokazuje błędy);
   - przycisk pod ekranem i produkt z wariantami → pasek mówi „Wybierz długość” i przewija do wyboru wariantu, żeby nie
     dodać długości, której klientka nie wybrała; bez wariantów pasek dodaje od razu.
   Pasek kopiuje z głównego formularza: napis (np. „Wyprzedane”), disabled, stan ładowania (klasa loading,
   aria-disabled; obserwator atrybutów), cenę i wybrany wariant. Gdy po kliknięciu w pasku pojawi się błąd
   formularza, strona przewija się do niego. Ukryty pasek jest inert (bez fokusu z klawiatury i czytnika). */
if (!customElements.get('lunaice-sticky-buy')) {
  customElements.define(
    'lunaice-sticky-buy',
    class LunaiceStickyBuy extends HTMLElement {
      connectedCallback() {
        this.main = document.getElementById(this.dataset.buttonId);
        if (!this.main || !('IntersectionObserver' in window)) return;

        this.button = this.querySelector('[data-sticky-add]');
        this.label = this.querySelector('[data-sticky-label]');
        this.spinner = this.button.querySelector('.loading__spinner');
        this.price = this.querySelector('[data-sticky-price]');
        this.variant = this.querySelector('[data-sticky-variant]');
        this.picker = document.getElementById(this.dataset.pickerId);
        this.form = this.main.closest('product-form');
        this.errorBox = this.form && this.form.querySelector('.product-form__error-message-wrapper');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.mode = 'add';
        this.mainState = 'visible';
        this.footerVisible = false;
        this.inert = true;
        this.removeAttribute('hidden');

        this.button.addEventListener('click', () => this.onClick());

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === this.main) {
              if (entry.isIntersecting) this.mainState = 'visible';
              else this.mainState = entry.boundingClientRect.top < 0 ? 'above' : 'below';
            } else {
              this.footerVisible = entry.isIntersecting;
            }
          }
          this.update();
        });
        this.observer.observe(this.main);
        this.footer = document.querySelector('.shopify-section-group-footer-group');
        if (this.footer) this.observer.observe(this.footer);

        // stan głównego przycisku (ładowanie, disabled) przenosimy na pasek na bieżąco
        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.main, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });

        // błąd po kliknięciu w pasku: przewiń do komunikatu nad głównym przyciskiem
        if (this.errorBox) {
          this.errorObserver = new MutationObserver(() => {
            if (this.clickedAt && Date.now() - this.clickedAt < 8000 && !this.errorBox.hidden) {
              this.clickedAt = 0;
              this.errorBox.scrollIntoView({ block: 'center', behavior: this.reduceMotion ? 'auto' : 'smooth' });
            }
          });
          this.errorObserver.observe(this.errorBox, { attributes: true, attributeFilter: ['hidden'] });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.stateObserver) this.stateObserver.disconnect();
        if (this.errorObserver) this.errorObserver.disconnect();
      }

      onClick() {
        if (this.mode === 'choose' && this.picker) {
          this.picker.scrollIntoView({ block: 'center', behavior: this.reduceMotion ? 'auto' : 'smooth' });
          const first = this.picker.querySelector('input:not([disabled]), select');
          if (first) first.focus({ preventScroll: true });
          return;
        }
        this.clickedAt = Date.now();
        this.main.click();
      }

      update() {
        const show = this.mainState !== 'visible' && !this.footerVisible;
        this.mode = this.mainState === 'below' && this.button.dataset.labelChoose ? 'choose' : 'add';
        if (show) this.sync();
        this.toggleAttribute('data-visible', show);
        this.inert = !show;
      }

      syncState() {
        const loading = this.main.classList.contains('loading') && this.mode === 'add';
        this.button.classList.toggle('loading', loading);
        if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
        if (this.mode === 'add') {
          this.button.disabled = this.main.disabled;
          if (this.main.getAttribute('aria-disabled') === 'true') this.button.setAttribute('aria-disabled', 'true');
          else this.button.removeAttribute('aria-disabled');
        } else {
          this.button.disabled = false;
          this.button.removeAttribute('aria-disabled');
        }
      }

      sync() {
        if (this.mode === 'choose') {
          this.label.textContent = this.button.dataset.labelChoose;
        } else {
          const mainLabel = this.main.querySelector('span');
          if (mainLabel && mainLabel.textContent.trim()) this.label.textContent = mainLabel.textContent.trim();
        }
        this.syncState();

        // wariant przy nazwie tylko w trybie „dodaj”: przy „Wybierz długość” klientka jeszcze nic nie wybrała
        if (this.variant && this.picker) {
          const values =
            this.mode === 'add'
              ? [...this.picker.querySelectorAll('input:checked, select')].map((el) => el.value).filter(Boolean)
              : [];
          this.variant.textContent = values.length ? ` · ${values.join(' / ')}` : '';
        }

        const priceBox = document.querySelector(`#${this.dataset.priceId} .price`);
        if (!priceBox || !this.price) return;
        const item = priceBox.classList.contains('price--on-sale')
          ? priceBox.querySelector('.price__sale .price-item--sale')
          : priceBox.querySelector('.price__regular .price-item--regular');
        if (item && item.textContent.trim()) this.price.textContent = item.textContent.trim();
      }
    }
  );
}
